<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-caret-down`]" width="1em" height="1em" v-bind="$attrs"><path d="M8.4 17.648A1 1 0 019.162 16h29.676a1 1 0 01.761 1.648L24.762 35.104a1 1 0 01-1.524 0L8.4 17.648z"/></svg>
</template>
<script>

export default {
  name: 'IconCaretDown',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
